<template>
  <el-form
    size="small"
    label-position="top"
  >
    <el-row :gutter="15">
      <el-col :md="12">
        <el-form-item
          label="Name"
          style="width: 95%;"
        >
          <el-select
            v-model="address.name"
            clearable
            filterable
            remote
            :remote-method="addressQuerySearch"
            :loading="isLoading"
            :trigger-on-focus="false"
            class="w-100"
            placeholder="Receiver Name"
            value-key="id"
            @change="handleSelectAddress"
          >
            <el-option
              v-for="item in autocompleteAddresses"
              :key="item.id"
              :label="formatAddress(item)"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item
          label="Residential"
        >
          <el-switch v-model="address.residential" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :md="12">
        <el-form-item
          label="Suburb/Town"
          prop="suburb"
        >
          <el-select
            ref="suburbInput"
            v-model="address.suburb"
            clearable
            filterable
            remote
            style="width: 90%;"
            :remote-method="suburbQuerySearch"
            :loading="isLoading"
            :trigger-on-focus="false"
            class="w-100"
            placeholder="Enter name of suburb"
            value-key="id"
            @change="handleSelectSuburb"
          >
            <el-option
              v-for="item in locations"
              :key="item.id"
              :label="formatSuburbByLocation(item)"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-row>
          <el-col
            :md="8"
          >
            <el-form-item
              label="State"
            >
              <el-input
                v-model="address.state"
                style="width: 90%;"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item
              label="Postcode"
            >
              <el-input
                v-model="address.postcode"
                style="width: 90%;"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item
              label="Country"
            >
              <el-input
                v-model="address.country"
                style="width: 90%;"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    address: {
      type: Object,
      required: false,
      default: Object
    },
    account: {
      type: Object,
      required: false,
      default: Object
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      autocompleteAddresses: [],
      locations: [],
      isLoading: false
    }
  },
  methods: {
    addressQuerySearch (queryString, cb) {
      if (!this.account.id) {
        return false
      }

      this.isLoading = true
      this.$sdk.account_address.list(builder => {
        builder.context = { resource: 'account', id: this.account.id }
        builder.filters = { 'name': queryString }
        builder.order = { 'name': 'asc' }
      }).then(res => {
        this.autocompleteAddresses = res
        this.isLoading = false
      })
    },
    suburbQuerySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.location.list(builder => {
        builder.filters = { 'query': queryString }
        builder.order = { 'suburb': 'asc' }
      }).then(res => {
        this.locations = res
        this.isLoading = false
      })
    },
    handleSelectSuburb (item) {
      console.log('Selected suburb', item)
      this.address.suburb = item.suburb
      this.address.state = item.state
      this.address.postcode = item.postcode
      this.address.country = item.country
      if (this.type === 'receiver') {
        console.log('Emitting set-suburb')
        this.$emit('set-suburb')
      } else {
        console.log('type not receiver, not emitting set-suburb')
      }
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    },
    handleSelectAddress (item) {
      this.address.name = item.name
      this.address.contact = item.contact
      this.address.line1 = item.line_one
      this.address.line2 = item.line_two
      this.address.phone = item.phone
      this.address.email = item.email
      this.address.suburb = item.suburb
      this.address.state = item.state
      this.address.postcode = item.postcode
      this.address.country = item.country
      if (this.type === 'receiver') {
        console.log('Emitting set-suburb')
        this.$emit('set-suburb')
      } else {
        console.log('type not receiver, not emitting set-suburb')
      }
    },
    formatAddress (address) {
      if (address) {
        return `[${address.code == null ? address.code : ''}] ${address.name}`
      } else return ''
    }
  }
}
</script>
<style>
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
